export const config = {
  gnosis: { gameFactoryContract: { address: "0x26D85eeDD1a0DD7376E4CfE036A00e0701Ce080F" } },
  local:  { gameFactoryContract: { address: "0xCf7Ed3AccA5a467e9e704C703E8D87F634fB0Fc9" } },
};
